import { AnimatePresence, motion } from 'motion/react';
import PropTypes from 'prop-types';

export default function FormContent({ children, step }) {
	const isFirstStep = step === 0;
	const animationProps = {
		opacity: 0,
		transform: isFirstStep ? 'translateX(-100%)' : 'translateX(100%)',
	};

	return (
		<AnimatePresence initial={false} mode="popLayout">
			<motion.div
				key={step}
				className="form__content"
				initial={animationProps}
				animate={{ opacity: 1, transform: 'translateX(0%)' }}
				exit={animationProps}
				transition={{ duration: 0.375, ease: 'easeInOut' }}
			>
				{children}
			</motion.div>
		</AnimatePresence>
	);
}

FormContent.propTypes = {
	children: PropTypes.node,
	step: PropTypes.number.isRequired,
};
